// Persistent business profile stored in localStorage.
// Shape: { nombreNegocio, giro, ciudad, redPrincipal, productos: [{nombre, precio, costo}] }
// Presence of a valid perfil switches the app's landing view from PerfilSetup to QuickStart.

const KEY = "negoia_perfil";

function isValid(p) {
  if (!p || typeof p !== "object") return false;
  if (typeof p.nombreNegocio !== "string" || !p.nombreNegocio.trim()) return false;
  if (typeof p.giro !== "string" || !p.giro.trim()) return false;
  if (typeof p.ciudad !== "string" || !p.ciudad.trim()) return false;
  if (!["facebook", "instagram", "whatsapp", "tiktok"].includes(p.redPrincipal)) return false;
  if (!Array.isArray(p.productos) || p.productos.length === 0) return false;
  return p.productos.every(
    (pr) =>
      pr &&
      typeof pr.nombre === "string" &&
      pr.nombre.trim() &&
      typeof pr.precio === "number" &&
      pr.precio > 0,
  );
}

export function readPerfil() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return isValid(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function writePerfil(perfil) {
  try {
    localStorage.setItem(KEY, JSON.stringify(perfil));
    return true;
  } catch {
    return false;
  }
}

export function clearPerfil() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export const RED_PRINCIPAL_OPTIONS = [
  { id: "facebook", label: "Facebook" },
  { id: "instagram", label: "Instagram" },
  { id: "whatsapp", label: "WhatsApp" },
  { id: "tiktok", label: "TikTok" },
];
